// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"197":"c495f74c","638":"051257ae","676":"91abebcb"}[chunkId] + ".chunk.css";
};